<template>
<div class="i-layout-sider-logo">
  <a href="/" target="_self" class="i-link i-link-color">
    <span class="title" v-if="!isCollapsed">{{ title }}</span>
    <span class="title" v-else>{{ smalltitle }}</span>
  </a>
</div>
<Menus :isCollapsed="isCollapsed"/>
</template>

<script>
import Menus from '@/components/permission/Menus.vue'
export default {
  name: 'SiderLayout',
  props:{
    isCollapsed: Boolean
  },
  components: {
    Menus
  },
  data(){
    return{
      title:'电路设计及原理仿真实训系统',
      smalltitle:'电路设计'
    }
  }
}
</script>
<style lang="less" scoped>
@font-face{
	font-family:youshehei;
	src:url( '../assets/优设标题黑.TTF' );
}
.title{
  color: #fff;
  font-family: youshehei;
  font-weight: 400;
  font-size: 18px;
}
</style>
